module.exports = __webpack_public_path__ + "static/img/bgimg3-3.5281051b.png";